import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectNotesTab } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { useStyles } from "./styles";

const NotesTab = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(selectNotesTab);

  if (!data) {
    return null;
  }

  const handleAddNote = () => {
    const trimmed = data.draft.trim();
    if (!trimmed) {
      return;
    }

    dispatch(
      actions.addNote({
        id: `note-${Date.now()}`,
        roleKey: "VECHILE_STATUS.NOTES.ROLE_MANAGER",
        timestamp: new Date().toLocaleString("he-IL", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }),
        content: trimmed,
      })
    );
  };

  return (
    <Box className={styles.content}>
      <Box className={styles.section}>
        <Typography className={styles.label}>
          {t("VECHILE_STATUS.DETAIL_TABS.NOTES")}
        </Typography>
        <TextField
          className={styles.textarea}
          value={data.draft}
          onChange={(event) =>
            dispatch(actions.setNotesDraft(event.target.value))
          }
          placeholder={t("VECHILE_STATUS.NOTES.PLACEHOLDER")}
          fullWidth
          multiline
          variant="outlined"
        />
        <Button
          variant="contained"
          className={styles.addButton}
          onClick={handleAddNote}
        >
          {t("VECHILE_STATUS.NOTES.ADD_NOTE")}
        </Button>
      </Box>

      <Box className={styles.divider} />

      <Typography className={styles.historyTitle}>
        {t("VECHILE_STATUS.NOTES.HISTORY")}
      </Typography>

      <Box className={styles.historyList}>
        {data.history.map((item) => (
          <Box key={item.id} className={styles.historyItem}>
            <Typography className={styles.historyMeta}>
              {t(item.roleKey)} • {item.timestamp}
            </Typography>
            <Typography className={styles.historyContent}>
              {item.content ??
                (item.contentKey ? t(item.contentKey) : "")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NotesTab;
